import {FC, HTMLAttributeAnchorTarget, MouseEvent, ReactNode} from 'react'
import {Link, To, useNavigate, LinkProps} from 'react-router-dom'
import {names} from 'shared/lib'
import styles from './style.module.scss'

type RefProps = {
  onClick?: VoidFunction
  title?: string
  children: ReactNode
  className?: string
  inline?: boolean
  disabled?: boolean
  to?: To | string | number
  asDiv?: boolean
  state?: LinkProps['state']
  disablePreventDefault?: boolean
  stopPropagation?: boolean
  target?: HTMLAttributeAnchorTarget
}

export const Ref: FC<RefProps> = (props) => {
  const navigate = useNavigate()
  const classNames = names(
    props.className,
    styles.link,
    !props.inline && styles.inlineBlock,
    props.disabled && styles.disabled,
    props.className
  )

  const onClick = (event: MouseEvent<HTMLAnchorElement | HTMLHeadingElement>) => {
    if (props.disabled) return
    if (!props.disablePreventDefault) event.preventDefault()
    if (props.stopPropagation) event.stopPropagation()
    if (props.onClick) props.onClick?.()

    if (props.to) navigate(String(props.to))
  }

  if (props.asDiv) {
    return (
      <div title={props.title} onClick={onClick} className={classNames}>
        {props.children}
      </div>
    )
  }

  return (
    <Link
      target={props.target}
      title={props.title}
      className={classNames}
      onClick={onClick}
      to={(props.to ?? '') as To}
      state={props.state}
    >
      {props.children}
    </Link>
  )
}
